/**
 * Tolstoy stories widget — mini-cart sync on add-to-cart.
 * Block visibility is handled via :has(.tolstoy-stories-tile) on the product block wrapper.
 */

import { Cart } from '@/components/helpers/cart'

declare global {
  interface Window {
    tolstoyAppKey?: string
    tolstoyWidget?: {
      subscribe: (event: string, callback: () => void, options: object) => void
    }
  }
}

export class TolstoyWidgetElement extends HTMLElement {
  connectedCallback() {
    this.onTolstoyReady(() => this.bindAddToCart())
  }

  private onTolstoyReady(run: () => void) {
    if (window.tolstoyWidget) {
      run()
      return
    }
    window.addEventListener('tolstoyWidgetReady', run, { once: true })
  }

  private bindAddToCart() {
    window.tolstoyWidget?.subscribe(
      'tolstoy_add_to_cart',
      () => window.setTimeout(() => Cart.dispatchRenderMiniCart(true), 1000),
      {}
    )
  }
}
